import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const ServicesTerms = () => {
  const sections = [
    {
      text: () => (
        <Box>
          <Typography>
            Topibro Technologies provides technology services including web
            development, mobile application development, UI/UX design, IT
            training and certification programs, co-working space facilities,
            and an online learning platform. The scope, timeline, pricing, and
            deliverables for each project or service engagement are defined in
            separate service agreements or proposals agreed upon between Topibro
            Tech and the client.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Payment Terms.</b> Fees for services are as quoted or agreed in
            writing. Invoices are due within the period specified on the
            invoice. Late payments may incur a penalty fee. Topibro Tech
            reserves the right to suspend or terminate services for accounts
            with outstanding balances. All fees are non-refundable unless
            otherwise expressly stated in a written agreement.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Service Availability.</b> We strive to ensure our services are
            available at all times; however, we do not guarantee uninterrupted
            or error-free access. We may suspend or modify any part of our
            services for maintenance, upgrades, or reasons beyond our control,
            and we will endeavor to provide reasonable notice where possible.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Training Programs.</b> Enrollment in any training or
            certification program is subject to availability and any
            prerequisites stated in the program description. Course content,
            schedules, and fees are subject to change. Topibro Tech reserves the
            right to cancel or reschedule programs and will provide participants
            with reasonable notice in such cases.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Co-working Space.</b> Use of Topibro Tech&apos;s co-working space
            is governed by separate co-working space terms and a booking
            agreement. Users must treat shared spaces and equipment with care
            and respect other members. Topibro Tech reserves the right to refuse
            access to any individual who violates house rules.
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Container sx={{ my: 10 }} id="services">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            Our Services
          </Typography>
          {sections.map((section, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {section.text()}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default ServicesTerms;
